export default __webpack_public_path__ + "static/media/balao-boundary.5f692a5b.png";